import { type ReactNode, useState } from "react"

import { accessStore } from "../../access/access-store"
import { useCabinetAccess } from "../../access/use-access"
import { initials } from "./profile-model"
import styles from "./profile.module.css"
import { LanguageBlock } from "./language-block"
import { MfaBlock } from "./mfa-block"
import { PasswordBlock, SessionsBlock, SignOutBlock } from "./security-blocks"

/**
 * 1-Э1.10 «Профиль и безопасность» администратора — /profile.
 *
 * Имя и роль, пароль, второй фактор, язык, свои входы, выход. Роль подписана «роль меняет
 * салон»: её здесь не выбирают, и человек должен понимать, к кому идти.
 */
export function ProfileScreen(): ReactNode {
  const { context } = useCabinetAccess()
  const [reloadKey, setReloadKey] = useState(0)

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <span className={styles.avatar} aria-hidden="true">
          {initials(context.user.displayName)}
        </span>
        <span className={styles.headerMain}>
          <span className={styles.name}>{context.user.displayName}</span>
          <span className={styles.muted}>
            {context.role.name} · роль меняет салон · {context.tenant.name}
          </span>
        </span>
      </div>

      <PasswordBlock
        passwordChangedAt={context.user.passwordChangedAt}
        onChanged={() => {
          // «Изменён сегодня» — из свежего профиля, а список входов — после закрытия остальных.
          void accessStore.refresh()
          setReloadKey((value) => value + 1)
        }}
      />
      <MfaBlock
        onChanged={() => {
          // Включённый фактор виден и в профиле (mfaEnabled), и в списке сотрудников
          // у владельца — поэтому профиль перечитывается, а не правится на месте.
          void accessStore.refresh()
        }}
      />
      <LanguageBlock current={context.user.locale} />
      <SessionsBlock title="Активные сеансы" reloadKey={reloadKey} />
      <SignOutBlock />
    </div>
  )
}
